import styled from "styled-components";

export const Container = styled.section`
  margin-top: 12rem;
  display: flex;
  align-items: center;
  gap: 2rem;

  .hability{
    display: flex;
    flex-direction: column;
    align-items: center;

    img{
      width: 3.4rem;
    }
  }

  h1 {
    font-size: 7rem;
  }

  h2{
    display: inline-block;
    // border-bottom: 0.2rem solid var(--blue);
    font-size :3rem;
    margin: 0rem;
    color: var(--blue);
  }

  h3{
    margin-top: 2rem;
    color: var(--blue);
  }

  p{
    font-size: 1.8rem;
    letter-spacing: 0.1rem;
    font-weight: 500;
  }
  
  .about-text{
    width:70%;  
  }

  .about-image{
    width:30%;
    text-align: center;
   img{
    width:60%;
     filter: grayscale(1);
     transition: filter 0.5s;
     &:hover{
       filter: grayscale(0);
     }
   }
  }
  @media (max-width: 1286px){
    .about-image{
      img{
        width: 80%;
        
    }
  }
  @media (max-width: 960px){
    display: block;
    text-align: center;
    .about-text{
      width:100%;  
    }
    .about-image{
      width: 50%;
      margin: 0 auto;
      max-width: 100%;
      margin-top: 4rem;
      img{
        width: 100%;
        filter: grayscale(1);
        transition: filter 0.5s;
        &:hover{
          filter: grayscale(0);
        }
    }
  }
  @media (max-width: 480px) {
    display: block;
    text-align: center;
    .about-text{
      width:100%;  
    }
    .about-image {
      width: 70%;
      margin: 0 auto;
      max-width: 100%;
      margin-top: 4rem;
      img{
        width: 100%;
        filter: grayscale(1);
        transition: filter 0.5s;
        &:hover{
          filter: grayscale(0);
        }
    }
  }


`;
